// @generated by protoc-gen-es v2.2.0
// @generated from file hmm/incubator/results.proto (package hmm.incubator, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";
import { file_hmm_apis_objective } from "../apis/objective_pb";
import { file_hmm_apis_shared } from "../apis/shared_pb";
import { file_hmm_incubator_study } from "./study_pb";

/**
 * Describes the file hmm/incubator/results.proto.
 */
export const file_hmm_incubator_results = /*@__PURE__*/
  fileDesc("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", [file_hmm_apis_objective, file_hmm_apis_shared, file_hmm_incubator_study]);

/**
 * Describes the message hmm.incubator.Result.
 * Use `create(ResultSchema)` to create a new message.
 */
export const ResultSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results, 0);

/**
 * Describes the enum hmm.incubator.Result.SigLevel.
 */
export const Result_SigLevelSchema = /*@__PURE__*/
  enumDesc(file_hmm_incubator_results, 0, 0);

/**
 * @generated from enum hmm.incubator.Result.SigLevel
 */
export const Result_SigLevel = /*@__PURE__*/
  tsEnum(Result_SigLevelSchema);

/**
 * Describes the enum hmm.incubator.Result.SigTest.
 */
export const Result_SigTestSchema = /*@__PURE__*/
  enumDesc(file_hmm_incubator_results, 0, 1);

/**
 * @generated from enum hmm.incubator.Result.SigTest
 */
export const Result_SigTest = /*@__PURE__*/
  tsEnum(Result_SigTestSchema);

/**
 * Describes the message hmm.incubator.MetricResult.
 * Use `create(MetricResultSchema)` to create a new message.
 */
export const MetricResultSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results, 1);

/**
 * Describes the message hmm.incubator.AppendixResult.
 * Use `create(AppendixResultSchema)` to create a new message.
 */
export const AppendixResultSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results, 2);

/**
 * Describes the message hmm.incubator.Diagnostics.
 * Use `create(DiagnosticsSchema)` to create a new message.
 */
export const DiagnosticsSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results, 3);

/**
 * Describes the message hmm.incubator.Diagnostics.Category.
 * Use `create(Diagnostics_CategorySchema)` to create a new message.
 */
export const Diagnostics_CategorySchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results, 3, 0);

/**
 * Describes the message hmm.incubator.Diagnostics.Pillar.
 * Use `create(Diagnostics_PillarSchema)` to create a new message.
 */
export const Diagnostics_PillarSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results, 3, 1);

/**
 * Describes the message hmm.incubator.Norms.
 * Use `create(NormsSchema)` to create a new message.
 */
export const NormsSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results, 4);

/**
 * Describes the message hmm.incubator.DriversDag.
 * Use `create(DriversDagSchema)` to create a new message.
 */
export const DriversDagSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results, 5);

/**
 * Describes the message hmm.incubator.DriversDag.Node.
 * Use `create(DriversDag_NodeSchema)` to create a new message.
 */
export const DriversDag_NodeSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results, 5, 0);

/**
 * Describes the message hmm.incubator.DriversDag.Link.
 * Use `create(DriversDag_LinkSchema)` to create a new message.
 */
export const DriversDag_LinkSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results, 5, 1);

/**
 * Describes the message hmm.incubator.SubjectAnswer.
 * Use `create(SubjectAnswerSchema)` to create a new message.
 */
export const SubjectAnswerSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results, 6);

/**
 * Describes the message hmm.incubator.SubjectAnswers.
 * Use `create(SubjectAnswersSchema)` to create a new message.
 */
export const SubjectAnswersSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results, 7);

/**
 * Describes the message hmm.incubator.LinkageReport.
 * Use `create(LinkageReportSchema)` to create a new message.
 */
export const LinkageReportSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results, 8);

/**
 * Describes the message hmm.incubator.LinkageReport.Ngram.
 * Use `create(LinkageReport_NgramSchema)` to create a new message.
 */
export const LinkageReport_NgramSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results, 8, 0);

/**
 * Describes the message hmm.incubator.LinkageReport.Result.
 * Use `create(LinkageReport_ResultSchema)` to create a new message.
 */
export const LinkageReport_ResultSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results, 8, 1);

/**
 * Describes the enum hmm.incubator.LinkageReport.Category.
 */
export const LinkageReport_CategorySchema = /*@__PURE__*/
  enumDesc(file_hmm_incubator_results, 8, 0);

/**
 * @generated from enum hmm.incubator.LinkageReport.Category
 */
export const LinkageReport_Category = /*@__PURE__*/
  tsEnum(LinkageReport_CategorySchema);

/**
 * Describes the message hmm.incubator.IncubatorAIResult.
 * Use `create(IncubatorAIResultSchema)` to create a new message.
 */
export const IncubatorAIResultSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_results, 9);

/**
 * Describes the enum hmm.incubator.IncubatorAIResult.Recommendation.
 */
export const IncubatorAIResult_RecommendationSchema = /*@__PURE__*/
  enumDesc(file_hmm_incubator_results, 9, 0);

/**
 * @generated from enum hmm.incubator.IncubatorAIResult.Recommendation
 */
export const IncubatorAIResult_Recommendation = /*@__PURE__*/
  tsEnum(IncubatorAIResult_RecommendationSchema);

